import crypto from "@/core/utils/crypto";
import { userApi } from "@/core/data/api";

export default async (id, values) => {
  return await userApi.changePassword(id, {
    oldPassword: crypto.sha256(values.oldPassword),
    newPassword: crypto.sha256(values.newPassword)
  });
};
